import React, { ReactElement, useEffect, useState } from "react";

import { selectShowSidebar } from "../Sidebar/module/selector";

import { showAndCloseSidebar } from "../Sidebar/module/actions";

import classes from "./Header.module.scss";
import { IoMdLogOut, IoMdMenu } from "react-icons/io";
import nexiWhiteLogo from "../../assets/images/Logo_Nexi_Group_Orizz_Bianco.png";

import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { ROUTES } from "../../module/constants";
import { push } from "connected-react-router";
import ExitModal from "../Modals/ExitModal/ExitModal";
import { IEnvironmentType, IHeaderProps } from "./module/constants";
import { logout, setAccessFromInternetAction } from "../../App/module/actions";
import LanguageSelect from "../LanguageSelect/LanguageSelect";
import NavigationStepper from "../NagivationStepper/NavigationStepper";
import { INT_HOST_LIST, STG_HOST_LIST } from "../../constants/env";

const Header: React.FC<IHeaderProps> = (props: IHeaderProps) => {
  const { show, showSidebar, changeLocation, logout } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [environment, setEnvironment] = useState(IEnvironmentType.PRODUCTION);

  const goHome = () => {
    setShowModal(true);
  };

  const closeModalHandler = () => {
    setShowModal(false);
  };

  const confirmModalHandler = () => {
    changeLocation(ROUTES.WELCOME);
    setShowModal(false);
  };

  useEffect(() => {
    const host = window.location.hostname;
    if (
      INT_HOST_LIST.filter((path: string) => host.includes(path)).length > 0
    ) {
      setEnvironment(IEnvironmentType.INTEGRATION);
    } else if (
      STG_HOST_LIST.filter((path: string) => host.includes(path)).length > 0
    ) {
      setEnvironment(IEnvironmentType.STAGING);
    } else {
      setEnvironment(IEnvironmentType.PRODUCTION);
    }
    /* eslint-disable no-restricted-globals */
  }, []);

  return (
    <header className={classes[`header${environment}`]}>
      <ExitModal
        show={showModal}
        onClose={closeModalHandler}
        onConfirm={confirmModalHandler}
      />
      <div className="row h-100">
        <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1 d-flex justify-content-center flex-wrap">
          <IoMdMenu onClick={() => showSidebar(!show)} />
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3  d-flex justify-content-start align-items-center flex-wrap">
          <NavigationStepper />
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 offset-sm-1 offset-md-1 offset-lg-1 offset-xl-1 d-flex justify-content-center align-items-center flex-wrap">
          {}
          <img
            className={classes["logo"]}
            src={nexiWhiteLogo}
            alt="header-icon"
            onClick={goHome}
          />
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 d-flex justify-content-center">
          {}
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 d-flex justify-content-center align-items-end">
          <LanguageSelect />
        </div>
        <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1 d-flex justify-content-center flex-wrap">
          <IoMdLogOut
            onClick={() => {
              logout();
              setAccessFromInternetAction(false);
            }}
          />
        </div>
      </div>
    </header>
  ) as ReactElement<any>;
};
const mapStateToProps: any = () =>
  createStructuredSelector({
    show: selectShowSidebar,
  });

const mapDispatchToProps: any = {
  showSidebar: (show: boolean) => showAndCloseSidebar(show),
  changeLocation: (url: any) => push(url),
  logout: () => logout(),
  setAccessFromInternet: setAccessFromInternetAction,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Header);
